import { render, staticRenderFns } from "./ComplaintContainer.vue?vue&type=template&id=5f56424e"
import script from "./ComplaintContainer.vue?vue&type=script&lang=ts"
export * from "./ComplaintContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports